import { useTranslate } from 'ra-core'

const AdSiteTitle = ({ record }: { record?: { name?: string } }) => {
  const translate = useTranslate()
  return (
    <span>
      {translate('Ad Site')} - {record && record.name ? `"${record.name}"` : ''}
    </span>
  )
}

export default {
  list: { lazy: () => import('./AdSiteList') },
  edit: { lazy: () => import('./AdSiteEdit') },
  create: { lazy: () => import('./AdSiteCreate') },
  options: {
    create: {
      title: 'Create Ad Site',
      subtitle: null,
      breadCrumb: 'Create Ad Site',
    },
    list: {
      title: 'Ad Sites',
      subtitle: null,
      breadCrumb: 'Ad Sites',
    },
    edit: {
      title: <AdSiteTitle />,
      subtitle: null,
      breadCrumb: 'Edit Ad Site',
    },
  },
}
